"use client";

import { useEffect, useId, useState } from "react";
import { cn } from "@/lib/utils";

export type TocItem = { id: string; heading: string };

export function TableOfContents({ items, className }: { items: TocItem[]; className?: string }) {
  const [active, setActive] = useState<string | null>(null);
  const labelId = useId();

  useEffect(() => {
    if (items.length === 0) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) setActive(entry.target.id);
        }
      },
      { rootMargin: "-96px 0px -68% 0px" },
    );
    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);

  return (
    <nav aria-labelledby={labelId} className={cn("toc", className)}>
      <p id={labelId} className="toc-label">
        On this page
      </p>
      <ol className="toc-list">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={cn("toc-link", active === item.id && "is-active")}
              onClick={() => setActive(item.id)}
            >
              {item.heading}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}